module.exports = "https://cdn.realtymogul.com/static/media/icon_heart.72b6fed2.svg";